// ======================================================================
// File Name       : ContentLinkListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { isInvalid, reduxForm, getFormValues } from 'redux-form';
import * as MessageTemplate from '../../constants/MessageTemplate';
import ContentLinkSearch from '../../components/content/ContentLinkSearch';
import ContentLinkList from '../../components/content/ContentLinkList';
import DialogConfirm from '../../components/DialogConfirm';
import { searchContentLinkList } from '../../actions/content/ContentLinkAction';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import {
  DATA_AFFIILIATION_TYPE,
  DATA_AFFIILIATION_TYPE_STR,
} from '../../constants/ContentConstant';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import * as Path from '../../constants/PathConstants';
import { CONTENT_LINK_DETAIL } from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';

class ContentLinkListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {
        contentSecernIdList: [],
        contentSecernId: '',
        contentName: '',
        createdDateFrom: null,
        createdDateTo: null,
        dataAffiliationType: DATA_AFFIILIATION_TYPE_STR.NOT_SELECT,
        linkSortType: -1,
        ascendingDescendingSort: 0,
        startPosition: 0,
        createdUserName: '', // Step 9.0.0
      },
      returnMaxNum: RETURN_MAX_NUM,
      contentLinkListInfo: null,
      contentLinkInfo: {
        linkContentList: [],
      },
      isAllowShowSearchMessage: false,
      showModal: false,
    };

    this.onSearchData = this.onSearchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.onFileExportCancel = this.onFileExportCancel.bind(this);
    this.onFileExportOk = this.onFileExportOk.bind(this);
    this.openFileExportConfirm = this.openFileExportConfirm.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.initData = this.initData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.searchData = this.searchData.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { searchCondition } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.setState(
      filterData,
    );
    this.initData();
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.CONTENT_LINK_LIST,
      searchCondition: formValues,
    });
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.linkSortType) {
        column = initialValues.linkSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(false, initialValues, column, startPosition);
    this.props.dispatch(searchContentLinkList(param));
  }

  createParams(isCSV, data, column, startPosition) {
    const listTemp = [];
    const filterData = {};
    if (data && data.createdDateFrom) {
      const createdDateFrom = data.createdDateFrom ? moment(data.createdDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER) : '';
      filterData.createdDateFrom = createdDateFrom;
    }
    if (data && data.createdDateTo) {
      const createdDateTo = data.createdDateTo ? moment(data.createdDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER) : '';
      filterData.createdDateTo = createdDateTo;
    }
    if (data && data.contentSecernId) {
      filterData.contentSecernId = data.contentSecernId;
    }
    if (data && data.dataAffiliationType) {
      filterData.dataAffiliationType = parseInt(data.dataAffiliationType, 10) < 0 ? null : parseInt(data.dataAffiliationType, 10);
    }
    if (data && data.contentName) {
      filterData.contentName = data.contentName;
    }
    // Step 9.0.0 START
    if (data && data.createdUserName) {
      filterData.createdUserName = data.createdUserName;
    }
    // Step 9.0.0 END

    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }

    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.linkSortType = column.sortBy;
    }

    if (!column) {
      filterData.ascendingDescendingSort = null;
      filterData.linkSortType = null;
    }

    let selectTargetData = 0;
    if (isCSV) {
      selectTargetData = 1;
    }
    if (!startPosition) {
      filterData.startPosition = 0;
    }
    filterData.returnMaxNum = RETURN_MAX_NUM;
    const param = {
      selectTargetData,
      searchInfo: filterData,
    };
    return param;
  }

  goToDetail(contentSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: Path.CONTENT_LINK_LIST,
        searchCondition: formValues,
      });
    }
    const path = CONTENT_LINK_DETAIL.replace(':id', contentSecernId);
    this.props.history.push(path);
  }

  onSearchData() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      ...this.state.filterData,
      contentSecernId: formValues.contentSecernId,
      contentName: formValues.contentName,
      createdDateFrom: formValues.createdDateFrom,
      createdDateTo: formValues.createdDateTo,
      dataAffiliationType: formValues.dataAffiliationType,
      linkSortType: formValues.linkSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      startPosition: formValues.startPosition,
      createdUserName: formValues.createdUserName, // Step 9.0.0
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(false, filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('linkSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(searchContentLinkList(paramSearch))
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  searchData(startPosition, column) {
    const { formValues, invalid, dispatch } = this.props;
    const { filterData } = this.state;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(false, filterData, column, startPosition);
    this.props
      .dispatch(
        searchContentLinkList(paramSearch),
      )
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.linkSortType) {
      column = formValues.linkSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  openFileExportConfirm(mdContent, mdSize) {
    const { formValues } = this.props;
    if (
      formValues &&
      (!formValues.syncErrors || formValues.syncErrors.length === 0)
    ) {
      this.content = mdContent;
      this.mdSize = mdSize;
      this.setState({ showModal: true });
    }
  }

  onFileExportCancel() {
    this.setState({ showModal: false });
  }

  onFileExportOk() {
    const { formValues, invalid, dispatch } = this.props;
    const { filterData } = this.state;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(true, filterData, null, 0);
    this.props
      .dispatch(
        searchContentLinkList(paramSearch),
      )
      .then(() => {
        this.setState({ showModal: false });
      });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const recordNum = this.props.contentLinkInfo ? this.props.contentLinkInfo.recordNum : 0;
    const linkContentList = this.props.contentLinkInfo ? this.props.contentLinkInfo.linkContentList : [];
    const { hoverIndex } = this.state;
    return (
      <div>
        <Header name='リンク' />
        <MessageSearch
          recordNum={recordNum}
          resultList={linkContentList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <ContentLinkSearch
          contentLinkSearchInfo={this.props.contentLinkSearchInfo}
          recordNum={recordNum}
          startPosition={this.state.startPosition}
          getStartEndData={this.getStartEndData}
          onSearchBtnClick={this.onSearchData}
          onExportBtnClick={this.openFileExportConfirm.bind(
            this,
            MessageTemplate.BULK_EXPORT,
            null,
          )}
        />
        <ContentLinkList
          contentLinkInfo={this.props.contentLinkInfo}
          handleSortState={this.handleSortState}
          dataSort={this.state}
          goToDetail={this.goToDetail}
          recordNum={recordNum}
          getStartEndData={this.getStartEndData}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onFileExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onFileExportOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const invalid = isInvalid('contentLinkSearch')(state);
  const { content } = state;
  const { contentLinkInfo } = content;
  const { parentPath, searchCondition } = state.page;
  let initial = {
    dataAffiliationType: DATA_AFFIILIATION_TYPE_STR.NOT_SELECT,
  };
  if (parentPath === Path.CONTENT_LINK_LIST) {
    const paramSearch = {};
    if (searchCondition) {
      paramSearch.contentSecernId = searchCondition.contentSecernId;
      paramSearch.contentName = searchCondition.contentName;
      paramSearch.createdDateFrom = searchCondition.createdDateFrom;
      paramSearch.createdDateTo = searchCondition.createdDateTo;
      paramSearch.dataAffiliationType = searchCondition.dataAffiliationType;
      paramSearch.linkSortType = searchCondition.linkSortType;
      paramSearch.ascendingDescendingSort = searchCondition.ascendingDescendingSort;
      paramSearch.startPosition = searchCondition.startPosition;
      paramSearch.createdUserName = searchCondition.createdUserName; // Step 9.0.0
    }
    initial = paramSearch;
  }
  return {
    initialValues: initial,
    content,
    invalid,
    parentPath,
    searchCondition,
    formValues: getFormValues('contentLinkList')(state),
    contentLinkInfo,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'contentLinkList', // a unique identifier for this form
  touchOnChange: true,
})(ContentLinkListContainer));
